/* eslint-disable */
import cgtAxios from "../cgt-axios";
import cgtConfig from "../cgt-config";



class IbonazzService {
  appVersion=cgtConfig.appVersion;
  apiURL=cgtConfig.apiURL;

  /*** Types  */
  getTypeList() {
    var token=JSON.parse(localStorage.getItem(cgtConfig.defAUTHUSERTAG));
    const axiosConnect = cgtAxios(cgtConfig.apiURL);
    
    return axiosConnect.post(`/typedef/listall.php`,{ ca: token, ver:this.appVersion  });
  }
  
  // Tur 
  getTurList() {
    var token=JSON.parse(localStorage.getItem(cgtConfig.defAUTHUSERTAG));
    const axiosConnect = cgtAxios(cgtConfig.apiURL);
    return axiosConnect.post(`/turlar/listall.php`,{ ca: token, ver:this.appVersion  });
    //return axiosConnect.post(`/turlar/listall.php`,{ ca: token, ver:this.appVersion,qr:sqlCmdLine  });
  }
  
  getFilteredTurList(qr) {
    
    var token=JSON.parse(localStorage.getItem(cgtConfig.defAUTHUSERTAG));
    const axiosConnect = cgtAxios(cgtConfig.apiURL);
    return axiosConnect.post(`/turlar/list.php`,{ ca: token, ver:this.appVersion, qr:qr });
    //return axiosConnect.post(`/turlar/listall.php`,{ ca: token, ver:this.appVersion,qr:sqlCmdLine  });
  }
  
  addTur(data) {
    var token=JSON.parse(localStorage.getItem(cgtConfig.defAUTHUSERTAG));
    const axiosConnect = cgtAxios(cgtConfig.apiURL);
  
    return axiosConnect.post(`/turlar/add.php`,{ ca: token, ver:this.appVersion ,...data });
  }
  
  updateTur(data) {
    var token=JSON.parse(localStorage.getItem(cgtConfig.defAUTHUSERTAG));
    const axiosConnect = cgtAxios(cgtConfig.apiURL);
  
    return axiosConnect.post(`/turlar/update.php`,{ ca: token, ver:this.appVersion ,...data });
  }

  delTur(id) {
    var token=JSON.parse(localStorage.getItem(cgtConfig.defAUTHUSERTAG));
    const axiosConnect = cgtAxios(cgtConfig.apiURL);
    return axiosConnect.post(`/turlar/del.php`,{ ca: token, ver:this.appVersion ,id:id });
  }

  getTur(id) {
    var token=JSON.parse(localStorage.getItem(cgtConfig.defAUTHUSERTAG));
    const axiosConnect = cgtAxios(cgtConfig.apiURL);
    return axiosConnect.post(`/turlar/get.php`,{ ca: token, ver:this.appVersion ,id:id });
  }

  // Terminal
  getTerminalList() {
    var token=JSON.parse(localStorage.getItem(cgtConfig.defAUTHUSERTAG));
    const axiosConnect = cgtAxios(cgtConfig.apiURL);
    return axiosConnect.post(`/terminal/listall.php`,{ ca: token, ver:this.appVersion  });
  }
    openTerminal(id) {
    var token=JSON.parse(localStorage.getItem(cgtConfig.defAUTHUSERTAG));
    const axiosConnect = cgtAxios(cgtConfig.apiURL);
    return axiosConnect.post(`/terminal/open.php`,{ ca: token, ver:this.appVersion ,id:id });
  }  

  closeTerminal(id) {
    var token=JSON.parse(localStorage.getItem(cgtConfig.defAUTHUSERTAG));
    const axiosConnect = cgtAxios(cgtConfig.apiURL);
    return axiosConnect.post(`/terminal/close.php`,{ ca: token, ver:this.appVersion ,id:id });
  }  

}

export default new IbonazzService();

